import { readBoolean, readDateIso, readString } from "./mapperUtils.js";

export type CmtsSlaVm = {
  id: string;
  complaintId: string;
  complaintNumber: string;
  title: string;
  ownerId: string;
  ownerName: string;
  priorityCode: string;
  priorityName: string;
  slaRuleId: string;
  profileCode: string;
  status: string;
  slaStatus: string;
  responseDueAt: string;
  containmentDueAt: string;
  resolutionDueAt: string;
  verificationDueAt: string;
  paused: boolean;
  breach: boolean;
  nearBreach: boolean;
  calendarProfile: string;
};

export function mapSla(dto: unknown): CmtsSlaVm {
  const paused = readBoolean(dto, ["paused", "isPaused"], false);
  const breach = readBoolean(dto, ["breach", "isBreached"], false);
  const nearBreach = readBoolean(dto, ["nearBreach", "isNearBreach"], false);
  const rawStatus = readString(
    dto,
    ["slaStatus", "status", "slaStateCode", "state"],
    "",
  ).trim();
  const status = rawStatus || (
    paused ? "PAUSED" : breach ? "BREACHED" : nearBreach ? "NEAR_BREACH" : "WITHIN_SLA"
  );

  return {
    id: readString(dto, ["id", "slaId", "slaTrackerId"], ""),
    complaintId: readString(
      dto,
      ["complaintId", "linkedEntityId", "parentComplaintId"],
      "",
    ),
    complaintNumber: readString(
      dto,
      ["complaintNumber", "complaintCode", "linkedRecordCode"],
      "",
    ),
    title: readString(dto, ["title", "complaintTitle", "subject"], "SLA Tracker"),
    ownerId: readString(dto, ["ownerId", "ownerUserId", "complaintOwnerId"], ""),
    ownerName: readString(
      dto,
      ["ownerName", "ownerDisplayName", "complaintOwnerName"],
      "",
    ),
    priorityCode: readString(
      dto,
      ["priorityCode", "priority", "priorityName"],
      "",
    ),
    priorityName: readString(
      dto,
      ["priorityName", "priorityCode", "priority"],
      "",
    ),
    slaRuleId: readString(dto, ["slaRuleId", "ruleId"], ""),
    profileCode: readString(dto, ["profileCode", "slaProfileCode"], ""),
    status,
    slaStatus: status,
    responseDueAt: readDateIso(dto, ["responseDueAt", "responseDueAtUtc"], ""),
    containmentDueAt: readDateIso(
      dto,
      ["containmentDueAt", "containmentDueAtUtc"],
      "",
    ),
    resolutionDueAt: readDateIso(
      dto,
      ["resolutionDueAt", "resolutionDueAtUtc", "dueDate", "targetDateUtc"],
      "",
    ),
    verificationDueAt: readDateIso(
      dto,
      ["verificationDueAt", "verificationDueAtUtc"],
      "",
    ),
    paused,
    breach,
    nearBreach,
    calendarProfile: readString(
      dto,
      ["calendarProfile", "calendarProfileCode"],
      "",
    ),
  };
}